import { Node } from 'prosemirror-model';
import { IndentStep } from '@nimbus-library/features/shared/components/material/input-rich-text/input-rich-text-menu/lists-and-indent-toggle-group/indent.const';

export const paragraphNode: object = {
  attrs: { align: { default: undefined }, level: { default: 0 } },
  content: 'inline*',
  group: 'block',
  parseDOM: [
    {
      tag: 'p',
      getAttrs: (value: HTMLElement) => ({
        align: value.style['text-align'],
        level: Math.max(
          Math.round((parseInt(value.style['text-indent'] || 0) + parseInt(value.style['margin-left'] || 0)) / IndentStep),
          0,
        ),
      }),
    },
  ],
  toDOM: ({ attrs }: Node) =>
    attrs.level || attrs.align
      ? [
          'p',
          {
            style: `${attrs.align ? `text-align: ${attrs.align};` : ''}${
              attrs.level ? `margin-left: ${parseInt(attrs.level || 0) * IndentStep}pt` : ''
            }`,
          },
          0,
        ]
      : ['p', 0],
};
